
(function () {
  if (window.__tlGiftTitleLink) return;
  window.__tlGiftTitleLink = true;

  var handleByVariant = {};
  var origFetch = window.fetch;

  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === "string" ? input : input && input.url;
      if (url && /\/products\/[^/?]+\.js(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (product) {
            (product.variants || []).forEach(function (v) {
              handleByVariant[v.id] = product.handle;
            });
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  try {
    var style = document.createElement("style");
    style.textContent =
      ".tl__cart-goal__free-gift-reward-body .tl__cart-goal__product-image-info > p:first-child{cursor:pointer}" +
      ".tl__cart-goal__free-gift-reward-body .tl__cart-goal__product-image-info > p:first-child:hover{text-decoration:underline}";
    (document.head || document.documentElement).appendChild(style);
  } catch (e) {}

  document.addEventListener("click", function (e) {
    try {
      var title = e.target.closest && e.target.closest(".tl__cart-goal__product-image-info > p:first-child");
      var row = title && title.closest(".tl__cart-goal__free-gift-reward-body");
      var box = row && row.querySelector("[tl__cart-goal_data_id]");
      if (!box) return;

      var variantId = box.getAttribute("tl__cart-goal_data_id");
      var handle = handleByVariant[variantId];
      if (!handle) return; // chưa biết handle -> để popup chọn quà như cũ

      e.stopPropagation(); // chặn onclick chọn quà của dòng
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      window.open(root + "products/" + handle + "?variant=" + variantId, "_blank", "noopener");
    } catch (err) {}
  }, true);
})();
